// A substance id is "{un number}:{variant}:{regulation}", e.g. "2794:0002:IMDG_42".

export const regulationOf = (substanceId: string) =>
  substanceId.slice(substanceId.lastIndexOf(':') + 1);
